module.exports = __webpack_public_path__ + "img/service-fahrwerksuberprufung.06404015.jpg";